<template>

  <div class="block">
    <el-form>
      <el-form-item>
        <el-button type="danger" @click="dialogVisible=true">新增资产报警</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="新增资产报警" :visible.sync="dialogVisible" width="60%" @close="clearData">
      <el-form :model="tradingData" label-width="120px" :label-position="'right'">
        <el-form-item label="交易对">
          <el-input v-model="tradingData.symbol" placeholder="请输入交易对" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input v-model="tradingData.userId" placeholder="请输入用户id" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="代币最小值">
          <el-input v-model="tradingData.symbolMinBalance" placeholder="请输入代币最小数" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="usdt最小值">
          <el-input v-model="tradingData.usdtMinBalance" placeholder="请输入usdt最小数" type="number" required="required" clearable></el-input>
        </el-form-item>
        <el-form-item label="级别">
          <el-select v-model="tradingData.level">
            <el-option v-for="item in levelList" :label="item.label" :value="item.value" :key="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息频率" >
          <el-input v-model="tradingData.messageFrequency" placeholder="请输入级别" type="number" required="required" clearable></el-input>
        </el-form-item>
      <!-- <el-form-item label="报警群" prop="level">
        <el-select v-model="tradingData.level">
          <el-option v-for="item in groupList" :label="item.label" :value="item.value" :key="item.label"></el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item  label="是否打电话">
          <el-radio-group v-model="tradingData.isCall">
            <el-radio class="radio" :label="true">是</el-radio>
            <el-radio class="radio" :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  label="状态">
          <el-radio-group v-model="tradingData.enable">
            <el-radio class="radio" label="1">启动</el-radio>
            <el-radio class="radio" label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addTradingRisk">立即创建</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-form :inline="true">
      <el-form :inline="true">
        <el-form-item  label="交易对:">
          <el-autocomplete style="width: 50%;margin-right:5px" placeholder="输入搜索交易对" v-model="symbol"
                           :fetch-suggestions="querySymbol"  @change="buildSymbolInfo"/>
          <el-button type="primary" style="margin-right:5px" @click="buildSymbolInfo()">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-form>

    <el-form :model="symbolInfo" label-width="150px" ref="form">
      <el-form-item label="用户id" prop="userId">
        <el-input v-model="symbolInfo.userId"></el-input>
      </el-form-item>
      <el-form-item label="代币最小值" prop="symbolMinBalance">
        <el-input-number v-model="symbolInfo.symbolMinBalance"></el-input-number>
      </el-form-item>
      <el-form-item label="usdt最小值" prop="usdtMinBalance">
        <el-input-number v-model="symbolInfo.usdtMinBalance"></el-input-number>
      </el-form-item>
      <el-form-item label="级别" prop="level">
        <el-select v-model="symbolInfo.level">
          <el-option v-for="item in levelList" :label="item.label" :value="item.value" :key="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消息频率" prop="messageFrequency">
        <el-input-number v-model="symbolInfo.messageFrequency"></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="报警群" prop="level">
        <el-select v-model="symbolInfo.level">
          <el-option v-for="item in groupList" :label="item.label" :value="item.value" :key="item.label"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item  label="是否打电话" prop="isCall">
        <el-radio-group v-model="symbolInfo.isCall">
          <el-radio class="radio" :label="true">是</el-radio>
          <el-radio class="radio" :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item  label="状态" prop="enable">
        <el-radio-group v-model="symbolInfo.enable">
          <el-radio class="radio" :label="1">启动</el-radio>
          <el-radio class="radio" :label="0">禁止</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateTradingRisk()">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>


import utils from "@/entries/RiskController/utils";

export default {
  name: "AssetsChangeController",
  data(){
    return{
      symbol:'',
      formInfo:{},
      activeName:'risk1',
      tableData:[],
      tradingData:{
        id:0,
        userId:'',
        symbol:'',
        symbolMinBalance:'',
        usdtMinBalance:'',
        level:'',
        enable:'',
        messageFrequency:'',
        isCall:""
      },
      restaurants: [],
      dialogVisible: false,
      symbolInfo:{},
      symbolList: [],
      levelList: [{label:'主区',value:1},{label:'其他',value:2},{label:'项目方',value:3}],
      groupList: [{label: 'group_cex', value: 'group_cex'},{label: 'group_dex', value: 'group_dex'},{label: 'group_dex1', value: 'group_dex1'}]
    }
  },
  computed: {

  },
  methods: {

    clearData(){
      this.tradingData = {
        id:0,
        userId:'',
        symbol:'',
        symbolMinBalance:'',
        usdtMinBalance:'',
        level:'',
        enable:'',
        messageFrequency:'',
        isCall:""
      }
    },
    addTradingRisk(){
      utils.addOrUpdateAssetsChangeAlarm(this.tradingData).then((response)=>{
        if (response.code == 0){
          this.$message.success("添加成功")
          this.query();
        }else {
          this.$message.error("添加失败")
        }
      })
    },
    updateTradingRisk(){
      utils.addOrUpdateAssetsChangeAlarm(this.symbolInfo).then((response)=>{
        if (response.code == 0){
          this.$message.success("更新成功")
          this.query();
        }else {
          this.$message.error("更新失败")
        }
      })
    },
    query(){
      utils.queryAssetsChangeAlarm().then((response)=>{
        this.symbolList = response.data;
      })
    },
    querySymbol(queryString,cb) {
      let restaurants = this.symbolList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].symbol});
      }
      cb(suggest);

    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.symbol.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    buildSymbolInfo(){
      this.symbolInfo = {};
      for (let i in this.symbolList) {
        if (this.symbol === this.symbolList[i].symbol) {
          this.symbolInfo = JSON.parse(JSON.stringify(this.symbolList[i]));
          return;
        }
      }
    },
  },
  mounted() {
  },
  created(){
    this.query();
  }
}
</script>

<style scoped>

</style>